// extracted by mini-css-extract-plugin
module.exports = {"Tab":"RadixTabs_Tab__2kww_"};